import { DESIGN_HUDDLE_SCRIPT_SRC } from './constants'
import { FC } from 'react'
import Script, { ScriptProps } from 'next/script'

type DesignHuddleScriptProps = Pick<ScriptProps, 'onError' | 'onLoad'>

export const DesignHuddleScript: FC<DesignHuddleScriptProps> = ({ onError, onLoad }) => (
  <Script
    src={DESIGN_HUDDLE_SCRIPT_SRC}
    data-testid="design-huddle-sdk-script"
    onError={onError}
    onLoad={onLoad}
  />
)
